import type { FormFieldModule } from './field-module.types';
import type { FormFieldType } from '@/forms/typings';

/**
 * Registry for frontend {@link FormFieldType} behavior (presenter + initial state / validations).
 */
export class FormFieldModuleRegistry {
  private modules = new Map<FormFieldType, FormFieldModule>();
  private fallbackModule: FormFieldModule | undefined;

  register(type: FormFieldType, module: FormFieldModule): FormFieldModuleRegistry {
    this.modules.set(type, module);
    return this;
  }

  /**
   * Primitive single fields (Input, Select, Date, …) share one module.
   */
  setFallbackModule(module: FormFieldModule): FormFieldModuleRegistry {
    this.fallbackModule = module;
    return this;
  }

  get(type: FormFieldType): FormFieldModule {
    const mod = this.modules.get(type) ?? this.fallbackModule;
    if (!mod) {
      throw new Error(
        `No field module registered for type "${type}" and no fallback module is set.`,
      );
    }
    return mod;
  }

  has(type: FormFieldType): boolean {
    return this.modules.has(type);
  }

  clear(): void {
    this.modules.clear();
    this.fallbackModule = undefined;
  }
}

export const fieldModuleRegistry = new FormFieldModuleRegistry();
